import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const generateReportConsultantIntranet = async (securityType) => {
  const url = `/reports/monthendscreensbyuniverse?securityType=${securityType}`;
  return request.get(url);
};

export const generateMultistatusFundReport = async () => {
  const url = '/fiduciaries/ubs-multistatus-fundsreport';
  return request.get(url);
};
